import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'


export const Title = ({children,color='#00416A;'}) => {
    return (
        <Typography component="h6" variant="h6" style={{color:color}}>
            {children}
        </Typography>
    )
}

Title.propTypes = {
    children: PropTypes.node,
};